function SearchParentsFor(start, cls, top) {
  var result;

  var parent = start.parentNode;
  if (parent && parent.getAttribute) {
    var pcls = parent.getAttribute("class");
    if (pcls) {
      var pclsArray = pcls.split(" ");
      for (var i = 0; i < pclsArray.length; i++) {
        if (pclsArray[i] == cls) {
          result = parent;
          break;
        }
      }
    }

    if (!result && (!top || parent != top)) {
      result = SearchParentsFor(parent, cls, top);
    }
  }

  return result;
}

function HandleSuccess(e) {
  var type = e.currentTarget.dataset.type;
  if (type != "consultation") {
    window.lintrk("track", { conversion_id: 24030218 });
    fbq("track", "Lead", {});
  }
  window.location.href =
    window.location.origin +
    "/pages/thank-you?type=" +
    encodeURIComponent(type);
}

function SendToKlaviyo(param, e, cb) {
  function TryNow(e) {
    if (window._learnq) {
      // console.log( "Sending to klaviyo with params:" + JSON.stringify( param ) );
      window._learnq.push(param);
      cb();
    } else {
      setTimeout(TryNow, 500);
    }
  }
  TryNow(e);
}

function HandleConsultationClick() {
  var popup = document.querySelector(".bridgman-consultation-popup");
  popup.setAttribute("style", "display: block");
  popup.classList.remove("hidden");
}

function showRequestCatalogueForm(element) {
  var catalogueForm = document.querySelector(".commercial-popup");

  if ((catalogueForm.style.display = "none")) {
    catalogueForm.style.display = "block";
  }
}

function handleFormNavigation(element) {
  // $('.book_actionbar .next,.bridgman_comm_catalogue_steps span:nth-child(1)').click(function (e) {
  //     console.log('I AM CLICKED');
  //     var catalogue_name = $('.book_image_outer.active').data('catalogue-name');
  //     if(catalogue_name == undefined){
  //       if($('.bookError').length == 0)
  //       {
  //         $('<p class="bookError" style="margin-top:10px;text-align:left;font-size: 18px;color:#c14848;font-weight: 500;">Select at least one Catalogue.</p>').insertBefore('.book_wrapper');
  //       }
  //     }else{
  //       $('.bridgman_catalogue_panel').addClass('hidden');;
  //       $('.panel_methods').removeClass('hidden');;
  //     }
  //     return false;
  //   });
  //   $('.methods_wrapper .next,.bridgman_comm_catalogue_steps span:last-child').click(function (e) {
  //     console.log('I AM CLICKED too');
  //     var method = $('.action_button.active').data('method');
  //     if(method == undefined){
  //       if($('.methodError').length == 0)
  //       {
  //         $('<p class="methodError" style="margin-top:10px;text-align:left;font-size: 18px;color:#c14848;font-weight: 500;">Select at least one method.</p>').insertAfter('.panel_methods .panel_heading');
  //       }
  //     }else{
  //       $('.bridgman_catalogue_panel').addClass('hidden');
  //       $('.panel_methods').addClass('hidden');
  //     }
  //     return false;
  //   });

  var parent = document.querySelector(".commercial-popup-inner");
  var method = $(".action_button.active").data("method");
  var count = 0;

  var methodsContainer = document.querySelector(".panel_methods");
  // methodsContainer.classList.toggle( "hidden" );
  if (method) {
    if (methodsContainer.classList.contains("hidden")) {
      methodsContainer.classList.remove("hidden");
    } else {
      methodsContainer.classList.add("hidden");
    }

    var forms = document.querySelectorAll(".bridgman_catalogue_panel");
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var formName = form.dataset.name;
      form.classList.add("hidden");
      if (formName == method) {
        form.classList.remove("hidden");
      }
    }
  } else {
    if (count > 0) {
      $(
        '<p class="methodError" style="margin-top:10px;text-align:left;font-size: 18px;color:#c14848;font-weight: 500;">Select at least one method.</p>'
      ).insertAfter(".panel_methods .panel_heading");
      count++;
    }
  }
}

function setTelInputFilter(textbox, inputFilter) {
  // Convert HTML Collection to an array:
  var inputArray = Array.prototype.slice.call(textbox);
  var eventArray = [
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mouseup",
    "select",
    "contextmenu",
    "drop",
  ];

  for (var i = 0; i < eventArray.length; i++) {
    var event = eventArray[i];
    for (var j = 0; j < inputArray.length; j++) {
      var input = inputArray[j];
      input.addEventListener(event, function () {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          this.value = "";
        }
      });
    }
  }
}

function onSearchBlur() {
  var mannualAddress = document.querySelector("#manual-address");
  mannualAddress.checked = false;
}

window.addEventListener("DOMContentLoaded", function (e) {
  $('a[ href="#consultation" ]').on("click", function () {
    HandleConsultationClick();
  });
  $('a[ href="#catalogue" ]').on("click", function () {
    showRequestCatalogueForm(e.currentTarget);
  });

  setTelInputFilter(
    document.querySelectorAll(".number-input"),
    function (value) {
      return /^\d*\.?\d*$/.test(value); // Allow digits and '.' only, using a RegExp
    }
  );
});

$(document).ready(function () {
  var whereDidYouHeaderAboutUs = document.getElementById(
    "catalogue_Where_did_you_hear_about_us"
  );
  if (whereDidYouHeaderAboutUs) {
    whereDidYouHeaderAboutUs.addEventListener("change", function () {
      //console.log('You selected: ', this.value);
      var input_other = document.getElementById(
        "catalogue_Where_did_you_hear_about_us_other"
      );
      if (this.value == "Other") {
        input_other.classList.remove("hide");
      } else {
        input_other.classList.add("hide");
      }
    });
  }

  $("#commercial-page-form-email").submit(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation(); // This is to prevent the .submit firing twice

    var submitBtn = e.currentTarget.querySelector(".request-btn");
    submitBtn.classList.add("submitting");
    submitBtn.setAttribute("disabled", "disabled");

    hj("event", "commercial_catalogue_request");
    var pannel = SearchParentsFor(e.currentTarget, "bridgman_catalogue_panel");

    var selectedCatalogues = document.querySelectorAll(".bridgman-commercial-catalogue-list-container .single_book .active");

    function HandleCatalogues(catalogueName, catalogueType) {
      document.querySelector(".catalogue-error-text").classList.add("hidden");
      var form = e.currentTarget;
      var _learnq = _learnq || [];

      var first_name = form.querySelector("#catalogue_First_Name").value;
      var last_name = form.querySelector("#catalogue_Last_Name").value;
      var email = form.querySelector("#catalogue_email").value;
      var phone_number = form.querySelector("#catalogue_Phone").value;
      var company_name = form.querySelector("#commercial-popup_Company_Name").value;
      var Postcode = form.querySelector("#post_code").value;
      var company_website = form.querySelector("#company_website").value;
      var company_sector = form.querySelector("#catalogue_sector").value;
      var project_type = form.querySelector("#catalogue_project_type").value;
      var installation_date = form.querySelector("#catalogue_Installation_Date").value;
      var expected_budget = form.querySelector("#catalogue_Expected_Budget").value;
      var accepts_marketing = form.querySelector("input[ name='data-capture' ]").checked;
      var Where_did_you_hear_about_us = form.querySelector('[name="catalogue_Where_did_you_hear_about_us"]').value;

      if (Where_did_you_hear_about_us == "Other") {
        Where_did_you_hear_about_us = form.querySelector('[name="catalogue_Where_did_you_hear_about_us_other"]').value;
      }

      var catalogue = {
        Response_Type: "Email",
        Catalogue_Type: catalogueType.toString(),
        Catalogue_Name: catalogueName,
        Postcode: Postcode,
        $email: email,
        $first_name: first_name,
        $last_name: last_name,
        $phone_number: phone_number,
        $company_name: company_name,
        $company_website: company_website,
        $company_sector: company_sector,
        $source: Where_did_you_hear_about_us,
        $project_type: project_type,
        $installation_date: installation_date,
        $expected_budget: expected_budget,
      };

      if (accepts_marketing && accepts_marketing == true) {
        catalogue.$accepts_marketing = accepts_marketing;
      }

      if (catalogue.$accepts_marketing) {
        var properties = {
          $email: email,
          Catalogue_Type: catalogue.Catalogue_Type,
          Catalogue_Name: catalogue.Catalogue_Name,
          $source: catalogue.$source,
          Response_Type: "Email",
          $accepts_marketing: catalogue.$accepts_marketing,
        };
      } else {
        var properties = {
          $email: email,
          Catalogue_Type: catalogue.Catalogue_Type,
          Catalogue_Name: catalogue.Catalogue_Name,
          $source: catalogue.$source,
          Response_Type: "Email",
        };
      }

        let mergedProperties = properties;
        let mergedCatalogue = catalogue;
        const utmProperties = utmParams();
        if( utmProperties ){
            mergedProperties = {...properties, ...utmProperties};
            mergedCatalogue = {...catalogue, ...utmProperties};
        }

      var trackProperties = {
        event: "Request Catalogue",
        trackData: mergedCatalogue,
      };
      KlaviyoTrackV2(mergedProperties, trackProperties, function () {
        jQuery
          .post("https://hooks.zapier.com/hooks/catch/9220888/2mlk13x/", mergedCatalogue)
          .then(function () {
            HandleSuccess(e);
            submitBtn.classList.remove("submitting");
            submitBtn.setAttribute("disabled", "disabled");
          });
      });
    }

    if (selectedCatalogues && selectedCatalogues.length > 0) {
      var catalogueName = [];
      var catalogueType = [];
      if (selectedCatalogues.length > 1) {
        for (var i = 0; i < selectedCatalogues.length; i++) {
          catalogueName.push(
            selectedCatalogues[i].getAttribute("data-catalogue-name")
          );
          if (
            catalogueType.includes(
              selectedCatalogues[i].getAttribute("data-catalogue-type")
            ) == false
          ) {
            catalogueType.push(
              selectedCatalogues[i].getAttribute("data-catalogue-type")
            );
          }
        }
        catalogueName = "MULTIPLE - " + catalogueName.toString();
      } else {
        catalogueName = selectedCatalogues[0].getAttribute("data-catalogue-name");
        catalogueType.push(
          selectedCatalogues[0].getAttribute("data-catalogue-type")
        );
      }
      HandleCatalogues(catalogueName, catalogueType);
    } else {
      var parent = e.currentTarget.parentNode;
      parent.querySelector(".catalogue-error-text").classList.remove("hidden");
    }
  });

  $("#commercial-page-form").submit(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation(); // This is to prevent the .submit firing twice

    var submitBtn = e.currentTarget.querySelector(".request-btn");
    submitBtn.classList.add("submitting");
    submitBtn.setAttribute("disabled", "disabled");

    hj("event", "commercial_catalogue_request");
    var selectedCatalogues = document.querySelectorAll(".bridgman-commercial-catalogue-list-container .single_book .active");

    function HandleCatalogues(catalogueName, catalogueType) {
      document.querySelector(".catalogue-error-text").classList.add("hidden");
      var form = e.currentTarget;
      var _learnq = _learnq || [];

      var first_name = form.querySelector("#catalogue_First_Name").value;
      var last_name = form.querySelector("#catalogue_Last_Name").value;
      var email = form.querySelector("#catalogue_email").value;
      var phone_number = form.querySelector("#catalogue_Phone").value;
      var company_name = form.querySelector("#commercial-popup_Company_Name").value;
      var Postcode = form.querySelector("#post_code").value;
      var Address_Line_1 = form.querySelector("#address_line_1").value;
      var Address_Line_2 = form.querySelector("#address_line_2").value;
      var City = form.querySelector("#city").value;
      var Country = form.querySelector("#country").value;
      var company_website = form.querySelector("#company_website").value;
      var company_sector = form.querySelector("#catalogue_sector").value;
      var project_type = form.querySelector("#catalogue_project_type").value;
      var installation_date = form.querySelector("#catalogue_Installation_Date").value;
      var expected_budget = form.querySelector("#catalogue_Expected_Budget").value;
      var accepts_marketing = form.querySelector("input[ name='data-capture' ]").checked;
      var Where_did_you_hear_about_us = form.querySelector('[name="catalogue_Where_did_you_hear_about_us"]').value;

      if (Where_did_you_hear_about_us == "Other") {
        Where_did_you_hear_about_us = form.querySelector('[name="catalogue_Where_did_you_hear_about_us_other"]').value;
      }

      var catalogue = {
        Response_Type: "POST",
        Catalogue_Type: catalogueType.toString(),
        Catalogue_Name: catalogueName,
        Postcode: Postcode,
        $email: email,
        $first_name: first_name,
        $last_name: last_name,
        $address1: Address_Line_1,
        $address2: Address_Line_2,
        $city: City,
        $country: Country,
        $phone_number: phone_number,
        $company_name: company_name,
        $company_website: company_website,
        $company_sector: company_sector,
        $source: Where_did_you_hear_about_us,
        $project_type: project_type,
        $installation_date: installation_date,
        $expected_budget: expected_budget,
      };

      if (accepts_marketing && accepts_marketing == true) {
        catalogue.$accepts_marketing = accepts_marketing;
      }

      if (catalogue.$accepts_marketing) {
        var properties = {
          $email: email,
          Catalogue_Type: catalogue.Catalogue_Type,
          Catalogue_Name: catalogue.Catalogue_Name,
          $source: catalogue.$source,
          Response_Type: "POST",
          $accepts_marketing: catalogue.$accepts_marketing,
        };
      } else {
        var properties = {
          $email: email,
          Catalogue_Type: catalogue.Catalogue_Type,
          Catalogue_Name: catalogue.Catalogue_Name,
          $source: catalogue.$source,
          Response_Type: "POST",
        };
      }
      
        let mergedProperties = properties;
        let mergedCatalogue = catalogue;
        const utmProperties = utmParams();
        if( utmProperties ){
            mergedProperties = {...properties, ...utmProperties};
            mergedCatalogue = {...catalogue, ...utmProperties};
        }
      
      var trackProperties = {
        event: "Request Catalogue",
        trackData: mergedCatalogue,
      };
      KlaviyoTrackV2(mergedProperties, trackProperties, function () {
        jQuery
          .post("https://hooks.zapier.com/hooks/catch/9220888/2mlk13x/", mergedCatalogue)
          .then(function () {
            HandleSuccess(e);
            submitBtn.classList.remove("submitting");
            submitBtn.setAttribute("disabled", "disabled");
          });
      });
    }

    if (selectedCatalogues && selectedCatalogues.length > 0) {
      var catalogueName = [];
      var catalogueType = [];
      if (selectedCatalogues.length > 1) {
        for (var i = 0; i < selectedCatalogues.length; i++) {
          catalogueName.push(
            selectedCatalogues[i].getAttribute("data-catalogue-name")
          );
          if (
            catalogueType.includes(
              selectedCatalogues[i].getAttribute("data-catalogue-type")
            ) == false
          ) {
            catalogueType.push(
              selectedCatalogues[i].getAttribute("data-catalogue-type")
            );
          }
        }
        catalogueName = "MULTIPLE - " + catalogueName.toString();
      } else {
        catalogueName = selectedCatalogues[0].getAttribute("data-catalogue-name");
        catalogueType.push(
          selectedCatalogues[0].getAttribute("data-catalogue-type")
        );
      }
      HandleCatalogues(catalogueName, catalogueType);
    } else {
      var parent = e.currentTarget.parentNode;
      parent.querySelector(".catalogue-error-text").classList.remove("hidden");
    }
  });

  $("#consultation-page-form").submit(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var submitBtn = e.currentTarget.querySelector(".request-btn");
    submitBtn.classList.add("submitting");
    submitBtn.setAttribute("disabled", "disabled");

    var form = e.currentTarget;
    var _learnq = _learnq || [];

    var first_name = form.querySelector("#consulatation_Firstname").value;
    var last_name = form.querySelector("#consulatation_Lastname").value;
    var email = form.querySelector("#catalogue_email").value;
    var phone_number = form.querySelector("#catalogue_Phone").value;
    var company_name = form.querySelector("#commercial-popup_Company_Name").value;
    var company_website = form.querySelector("#company_website").value;
    var Postcode = form.querySelector('[name="catalogue_Postcode"]').value;
    var company_sector = form.querySelector("#catalogue_sector").value;
    var project_type = form.querySelector("#catalogue_project_type").value;
    var installation_date = form.querySelector("#catalogue_Installation_Date").value;
    var expected_budget = form.querySelector("#catalogue_Expected_Budget").value;
    var consultation_type = form.querySelector("#catalogue_Consultation_Type").value;
    var accepts_marketing = form.querySelector("input[ name='data-capture' ]").checked;
    var Where_did_you_hear_about_us = form.querySelector('[name="catalogue_Where_did_you_hear_about_us"]').value;

    if (Where_did_you_hear_about_us == "Other") {
      Where_did_you_hear_about_us = form.querySelector('[name="catalogue_Where_did_you_hear_about_us_other"]').value;
    }

    var consultationCustomer = {
      Catalogue_Type: "",
      $first_name: first_name,
      $last_name: last_name,
      $email: email,
      $phone_number: phone_number,
      $company_name: company_name,
      Postcode: Postcode,
      $company_website: company_website,
      $company_sector: company_sector,
      $source: Where_did_you_hear_about_us,
      $project_type: project_type,
      $installation_date: installation_date,
      $expected_budget: expected_budget,
      $consultation_type: consultation_type,
    };

    if (accepts_marketing && accepts_marketing == true) {
      consultationCustomer.$accepts_marketing = accepts_marketing;
    }

    if (consultationCustomer.$accepts_marketing) {
      var properties = {
        $email: email,
        Catalogue_Type: "",
        Catalogue_Name: "",
        $source: consultationCustomer.$source,
        Response_Type: "POST",
        $accepts_marketing: consultationCustomer.$accepts_marketing,
      };
    } else {
      var properties = {
        $email: email,
        Catalogue_Type: "",
        Catalogue_Name: "",
        $source: consultationCustomer.$source,
        Response_Type: "POST",
      };
    }

    let mergedProperties = properties;
    let mergedCustomer = consultationCustomer;
    const utmProperties = utmParams();
    if( utmProperties ){
        mergedProperties = {...properties, ...utmProperties};
        mergedCustomer = {...consultationCustomer, ...utmProperties};
    }

    var trackProperties = {
      event: "Request Consultation",
      trackData: mergedCustomer,
    };
    KlaviyoTrackV2(mergedProperties, trackProperties, function () {
      jQuery
        .post("https://hook.eu2.make.com/5juj73ocd7jmwifogma3v31b2tve1cjf", mergedCustomer)
        .then(function () {
          HandleSuccess(e);
          submitBtn.classList.remove("submitting");
          submitBtn.removeAttribute("disabled");
        });
    });
  });
});

window.addEventListener("DOMContentLoaded", function () {
  $(".consultation-popup-close").on("click", function () {
    document.querySelector(".bridgman-consultation-popup").removeAttribute("style");
    document.querySelector(".consultation-success").classList.add("hidden");
  });
});